import { render, staticRenderFns } from "./ExtraAlertReceiver.vue?vue&type=template&id=8b3289ce&"
import script from "./ExtraAlertReceiver.vue?vue&type=script&lang=js&"
export * from "./ExtraAlertReceiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports